import { render, staticRenderFns } from "./Parceria_SindirepaDuqueDeCaxias.vue?vue&type=template&id=b8e0ffe0"
import script from "./Parceria_SindirepaDuqueDeCaxias.vue?vue&type=script&lang=js"
export * from "./Parceria_SindirepaDuqueDeCaxias.vue?vue&type=script&lang=js"
import style0 from "./Parceria_SindirepaDuqueDeCaxias.vue?vue&type=style&index=0&id=b8e0ffe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports